const userType = {
  state: {
      userType: null, //1代表用户端，2代表服务端
  },
  getters: {
      getUserType(state) {
          return state.userType || JSON.parse(localStorage.getItem('userType'));
      },
  },
  mutations: {
      setUserType(state, num) {
          state.userType = num;
          localStorage.setItem('userType', num);
      },
  },
};

export default userType;


// WEBPACK FOOTER //
// ./src/store/modules/userType.js